import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Wizard from './Pages/Wizard/Wizard';
import Success from './Pages/Success/Success';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Wizard />} />
        <Route path="/device/:deviceId" element={<Wizard />} />
        <Route path="/:categorySlug" element={<Wizard />} />
        <Route path="/:categorySlug/:deviceSlug" element={<Wizard />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </BrowserRouter>
  );
}
